export default __webpack_public_path__ + "static/media/slider3.90d5bfea.jpg";